const ROUTES = {
  "/": {
    "name": "HomePage30159c9c07fe49d39d69F70d3a727136",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPages4028258404394980893642c72e888130",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPageA9385e22D47b47b7B823D77c74cedbbd",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/contact": {
    "name": "ContageUsPublic3b0d86d6F3c240d18688225c24b1f932",
    "type": "REFERENCE",
    "key": "contage-us-public"
  },
  "/events/public": {
    "name": "PublicEventsPageA635e902Fccd427bAb2730bc98452b65",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage259e8ab952b6412b803913c113f4fab1",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/login": {
    "name": "LoginPageD90e7e526dcb4f788e384c4df7d6b581",
    "type": "HTML",
    "key": "login-page"
  },
  "/members/*": {
    "name": "MemberPages46b0607e557549f28c1a0796dc4cf9a8",
    "type": "HTML",
    "key": "member-pages"
  },
  "/members/messages/*": {
    "name": "MessagePages0d7d7f94Fc4c4e988b9d73c0159c4e03",
    "type": "HTML",
    "key": "message-pages"
  },
  "/reset_password": {
    "name": "PasswordResetPageC3dd68a0C2bb4c77Ac1b9fad3c81b260",
    "type": "REFERENCE",
    "key": "password-reset-page"
  },
  "/resources": {
    "name": "ResourcesPage2eacc84d10fa423cA17f4634ebfcf79b",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPages56ba578e9a7645348e595baa46509e99",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;